import React, { useEffect } from "react";
import { Field, type FieldRenderProps, useForm } from "react-final-form";
import type { ValidationHandler } from "src/shared/forms/validations/ValidationHandler";

export interface ValidationProps {
  inputID: string;
  validate?: ValidationHandler;
}

export const Validation = (props: ValidationProps) => {
  const { mutators } = useForm();
  useEffect(() => {
    mutators.revalidate();
  }, [mutators, props.validate]);

  return (
    <Field {...props} name={props.inputID} component={ValidationRenderer} />
  );
};

const ValidationRenderer = ({ meta: { error } }: FieldRenderProps<unknown>) => {
  return <>{error}</>;
};

export const revalidate = () => {
  // an empty callback would just trigger revalidation
};
